// Versões independentes do produto.
//
// SITE_VERSION  -> alterações no frontend público (site).
// SYSTEM_VERSION -> alterações no backend: painel administrativo, banco de
//                   dados, APIs e regras de negócio.
//
// Cada camada é versionada por conta própria: uma mudança em uma não obriga
// a bumpar a outra. Formato: vMAJOR.MINOR.DDMMYY.
export const SITE_VERSION = 'v2.22.140826';
export const SYSTEM_VERSION = 'v1.9.270826';
